"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BadgeRewardNode = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_redux_1 = require("react-redux");
var item_dropdown_1 = require("../../../../../../../components/form/item-dropdown");
var reward_node_1 = __importDefault(require("../reward_node"));
var react_1 = require("react");
var challenge_1 = require("../../../../../../../reducers/slices/challenge/challenge");
var challengeEditorContext_1 = require("../../../../../../../contexts/challengeEditorContext");
var BadgeRewardNodeComponent = function (props) {
    var isReadOnly = (0, challengeEditorContext_1.useChallengeReadOnly)();
    var data = props.data;
    var dispatch = (0, react_redux_1.useDispatch)();
    var setConfigData = function (config) {
        dispatch((0, challenge_1.setNode)(__assign(__assign({}, props), { data: __assign(__assign({}, data), { config: config }) })));
    };
    var configurationComponent = function () {
        var _a;
        return ((0, jsx_runtime_1.jsx)("div", { className: "flex flex-col gap-2", children: (0, jsx_runtime_1.jsx)(item_dropdown_1.ItemDropdown, { label: "Badge", placeholder: "Search for a badge", item_type: "badge", is_disabled: isReadOnly, selected_item_ids: ((_a = data.config) === null || _a === void 0 ? void 0 : _a.value) ? [data.config.value] : [], on_selection_change: function (itemIds) { return setConfigData(__assign(__assign({}, data.config), { value: itemIds[0] })); } }) }));
    };
    return (0, jsx_runtime_1.jsx)(reward_node_1.default, __assign({ data: data }, props, { configurationComponent: configurationComponent }));
};
var BadgeRewardNode = (0, react_1.memo)(BadgeRewardNodeComponent);
exports.BadgeRewardNode = BadgeRewardNode;
